import {
  AfterViewChecked,
  Component,
  Inject,
  Input,
  OnInit,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { finalize, takeUntil } from 'rxjs/operators';

import {
  CreateFastScheduledMessageCommand,
  VoiceMessageDetailsRequest,
} from 'src/app/core/api/models';
import { ScheduledMessagesService } from 'src/app/core/api/services';
import { EventTypes } from 'src/app/core/constants/event-types';
import { RegularExpressions } from 'src/app/core/constants/regular-expressions';
import { ConsoleService } from 'src/app/core/services/console.service';
import { BaseSendSmsModule } from 'src/app/pages/sending-system/base/base-send-sms/base-send-sms.module';
import { BaseFormModule } from 'src/app/pages/shared/base';
import { SmsBodyModule } from 'src/app/shared/components/sms-body/sms-body.module';
import { ModalTitleComponent } from 'src/app/shared/global/modal-title/modal-title.component';
import { BaseFormPageComponent } from '../../../shared/base/components/base-form-page.component';
import { CustomerDomainFormComponent } from '../../customer-domains/domain-form/domain-form.component';

@Component({
    selector: 'app-test-send-form',
    templateUrl: './test-send-form.component.html',
    imports: [
        BaseFormModule,
        BaseSendSmsModule,
        SmsBodyModule,
        ModalTitleComponent,
    ]
})
export class TestSendFormComponent
  extends BaseFormPageComponent
  implements OnInit, AfterViewChecked
{
  //#region Properties
  @Input('privateNumberId') input_privateNumberId: number;

  model: CreateFastScheduledMessageCommand = {};
  smsBody: string = '';
  finalSmsBody: string = '';
  fastSendReceivers: string;
  isCanSendVoice: boolean;
  voiceMessageDetails?: VoiceMessageDetailsRequest;

  //#endregion

  constructor(
    protected currentService: ScheduledMessagesService,

    private dialogRef: MatDialogRef<CustomerDomainFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    super();
    this.model.senderNumberId = data?.privateNumberId;
    this.isCanSendVoice = data?.isCanSendVoice;
  }

  ngOnInit() {
    this.initForm();
    this.changeValidations();
  }

  ngAfterViewChecked(): void {
    this.cd.detectChanges();
  }

  initForm() {
    this.form = new FormGroup({
      smsBody: new FormControl('', [
        Validators.required,
        Validators.maxLength(64),
        // Validators.pattern(RegularExpressions.smsBodyForbiddenCharacters),
      ]),
      senderNumberId: new FormControl(''),
      voiceMessageId: new FormControl(''),
      maxTryCount: new FormControl(''),
      minuteBetweenTries: new FormControl(''),
    });
  }

  //#region Api

  //Create
  fastScheduledMessageApi(model: CreateFastScheduledMessageCommand) {
    this.unSubs();

    this.loading = true;

    this.currentService
      .scheduledMessagesCreateFastScheduledMessagePost({ body: model })
      .pipe(
        finalize(() => (this.loading = false)),
        takeUntil(this.onDestroy$)
      )
      .subscribe((result) => {
        this.onClose();
        this.apiNotificationService.notifyMessage({
          result,
          mode: 'matDialog',
        });
      });
  }

  //#endregion

  onFastSending() {
    this.fastScheduledMessageApi({
      receivers: this.fastSendReceivers,
      senderNumberId: this.model.senderNumberId,
      smsBody: this.smsBody,
      voiceMessageDetails: this.voiceMessageDetails,
    });
  }

  changeValidations() {
    try {
      this.form.get('voiceMessageId').clearValidators();
      this.form.get('smsBody').clearValidators();
      this.form.get('maxTryCount').clearValidators();
      this.form.get('minuteBetweenTries').clearValidators();

      // voiceMessageId
      if (this.isCanSendVoice) {
        this.form.get('voiceMessageId').setValidators([Validators.required]);
        this.form.get('maxTryCount').setValidators([Validators.required]);
        this.form
          .get('minuteBetweenTries')
          .setValidators([Validators.required]);
      }
      // smsBody
      else
        this.form
          .get('smsBody')
          .setValidators([
            Validators.required,
            // Validators.pattern(RegularExpressions.smsBodyForbiddenCharacters),
          ]);

      this.form.get('smsBody').updateValueAndValidity();
      this.form.get('voiceMessageId').updateValueAndValidity();
      this.form.get('maxTryCount').updateValueAndValidity();
      this.form.get('minuteBetweenTries').updateValueAndValidity();
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }

  onSubmit() {
    if (this.loading) return;
    if (!this.isValidForm(this.form, this.tagName)) return;

    try {
      if (this.loading || !this.form.valid) return;

      this.onFastSending();
    } catch (error) {
      ConsoleService.error('error', error);
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }

  onClose() {
    this.dialogRef.close();
  }

  onSuccess() {
    this.dialogRef.close(true);
    this.unSubs();
  }
}
